import type { ApolloCache } from "@apollo/client/cache"

import { ProductPositionTypename } from "shared/types/Project"

import {
  ProductPositionFragment,
  ProductPositionFragmentDoc
} from "entities/product-positions/graphql/fragments.generated"

export function readProductPositionFragment(
  id: string,
  cache: ApolloCache<object>
) {
  const cacheId = cache.identify({ id, __typename: ProductPositionTypename })
  if (!cacheId) {
    return null
  }
  return cache.readFragment<ProductPositionFragment>(
    {
      id: cacheId,
      fragmentName: "ProductPosition",
      fragment: ProductPositionFragmentDoc
    },
    true
  )
}
